import { matchPath } from "react-router-dom";
import _ from "lodash";
import { createCustomFormLinks, createMenuItems } from "./helpers";

const parentBackLinks = {
  production: { icon: "fa fa-arrow-left", label: "Back To Production", to: "/production", external: true },
  quality_assurance: { icon: "fa fa-arrow-left", label: "Back To QA", to: "/qa" },
  store: { icon: "fa fa-arrow-left", label: "Back To Store", to: "/store" },
};

const getBackLink = (menu, custom_forms_menus) => {
  if (!menu) return null;

  if(menu?.parent_type == "custom_menu") {
    return {
      icon: "fa fa-arrow-left",
      label: menu.parent_label,
      to: `/custom_forms/menus/${menu.parent_id}/module`,
    };
  }
  else{
    return parentBackLinks[menu?.parent_type] || {
      icon: "fa fa-arrow-left",
      label: "Back To Lion",
      to: `/custom_forms/menus/${menu.parent_id}/module`,
    }
  }
};

// Sidebar for a custom forms menu module page
const getCustomFormMenuModuleNav = (custom_forms_menus, menuId) => {
  const match = matchPath(window.location.pathname, {
    path: "/custom_forms/menus/:menu_id/module",
    exact: true,
  });

  const menu = custom_forms_menus[menuId || match?.params?.menu_id];
  const menuLabel = menu?.label || "";

  const childMenus = _(custom_forms_menus)
    .filter((m) => m.parent_type == "custom_menu" && m.parent_id == menu?.id)
    .sortBy("order")
    .value();

  let sidebarLinks = menu
    ? _.concat(createCustomFormLinks(menu.custom_forms), createMenuItems(childMenus))
    : [];

  const backLink = getBackLink(menu, custom_forms_menus);
  if (backLink) sidebarLinks.push(backLink);

  return { menuLabel, sidebarLinks };
};

export default getCustomFormMenuModuleNav;
